
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13303',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13303",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.866",
  "client-types": "static-1.501",
  "data-fetching-client": "static-1.9993",
  "foundations-components": "static-1.8549",
  "foundations-components-legacy": "static-1.1574",
  "foundations-theming": "static-1.4816",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.89",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8373",
  "hub-http-shared-msw-handlers": "static-1.10681",
  "hubspot-dlb": "static-2.1905",
  "hubspot-url-utils": "static-1.4366",
  "HubStyleTokens": "static-2.11832",
  "I18n": "static-7.1679",
  "jasmine-runner": "static-1.6790",
  "marketplace-discovery-studio-lib": "static-1.697",
  "marketplace-storefront-base": "static-1.13366",
  "quartz": "static-1.7507",
  "react-dlb": "static-1.89",
  "react-rhumb": "static-1.17063",
  "reactive-variable-buffer-atom": "static-1.3194",
  "reporting-testing-lib": "static-1.10856",
  "reselect": "static-3.12",
  "settings-ui-lib": "static-1.12864",
  "SharedI18nStrings": "static-1.183",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7675",
  "ui-addon-i18n": "static-1.11486",
  "ui-addon-react-router-dom": "static-1.9872",
  "unified-auth": "static-1.984",
  "unified-auth-core-lib": "static-1.1266",
  "usage-tracker": "static-1.7653",
  "usage-tracker-core": "static-1.7503",
  "customer-data-property-utils": "static-1.8438",
  "hub-http": "static-1.6552",
  "integrations-lib": "static-1.17142",
  "marketplace-ui-common": "static-1.20805",
  "marketplace-ui-install": "static-1.791",
  "property-management-iframe": "static-1.14204",
  "quartz-config": "static-1.1285",
  "quartz-core": "static-1.6726",
  "quartz-routing": "static-1.937",
  "quick-fetch": "static-1.4153",
  "react": "static-7.196",
  "rpc-client-utils": "static-1.5006",
  "ts-schema": "static-1.4319",
  "ui-universal-auth": "static-1.9470",
  "UIComponents": "static-3.8778",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.87",
  "metrics-js": "static-1.9963",
  "react-redux": "static-7.79",
  "redux": "static-4.80",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3784",
  "quartz-webpack": "static-1.3731",
  "bend-plugin-quartz-routing": "static-1.585",
  "ai-components-ui-library": "static-1.9795",
  "codemirror": "static-5.102",
  "foundations-assets": "static-1.5227",
  "pulse": "static-1.970",
  "react-codemirror": "static-1.10983",
  "ui-extensions-preview-lib": "static-1.679",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4818",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2532",
  "framer-motion": "static-1.79",
  "hs-story-utils": "static-1.9765",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.78",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5581",
  "react-virtualized": "static-2.107",
  "StyleGuideUI": "static-3.507",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2736",
  "ui-fonts": "static-1.1094",
  "ui-images": "static-2.1262",
  "bend-plugin-foundations-theming": "static-1.3299",
  "foundations-theming-base": "static-1.3801",
  "stylex": "static-1.41",
  "HeadJS": "static-2.803",
  "hs-test-utils-bend-plugin": "static-1.3484",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4652",
  "ui-addon-video-player": "static-1.9042",
  "ai-rendering-library": "static-1.11165",
  "chirp-fetch": "static-1.2236",
  "connections-embed-lib": "static-1.1565",
  "copilot-toolkit": "static-1.11910",
  "feedback-loader": "static-1.29861",
  "laboratory-lib": "static-3.7493",
  "marketplace-embed": "static-1.22983",
  "marketplace-ui-details": "static-1.10700",
  "marketplace-ui-reviews": "static-1.20760",
  "marketplace-ui-tracking": "static-1.14975",
  "sanitize-text": "static-1.8497",
  "usage-tracker-multi": "static-1.6067",
  "usage-tracker-session-replay": "static-1.5339",
  "wootric-nps": "static-1.7226",
  "quartz-head": "static-1.1172",
  "web-vitals": "static-1.15",
  "apollo-link-hub-http": "static-2.4997",
  "immer": "static-1.101",
  "immerable": "static-1.4486",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2716",
  "reporting-data": "static-1.68923",
  "cssUtils": "static-1.962",
  "flux-actions": "static-1.373",
  "react-colorpicker": "static-2.10553",
  "react-dnd-compat": "static-1.4956",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10710",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7643",
  "icons": "static-2.693",
  "marketplace-ui-apps-core": "static-1.19337",
  "storybook-react": "static-1.40",
  "trellis-story-utils": "static-1.4847",
  "foundations-components-test-utils": "static-1.6032",
  "quartz-i18n": "static-1.1182",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.535",
  "ads-unified-auth-lib": "static-1.1504",
  "custom-vendor-connection-lib": "static-1.34",
  "google-sheets-integration-lib": "static-1.1098",
  "microsoft-drive-auth-lib": "static-1.217",
  "surveymonkey-integration-lib": "static-1.554",
  "slack-ui-library": "static-1.10739",
  "fsm": "static-1.4093",
  "customer-data-objects": "static-1.8037",
  "property-translator": "static-1.5734",
  "hs-locale-management": "static-1.320",
  "frontend-preferences-client": "static-1.8259",
  "hs-promise-utils": "static-1.5930",
  "hubspot-apollo-client": "static-1.5217",
  "integrations-error-boundary-lib": "static-1.14557",
  "integrations-tracking-lib": "static-1.5948",
  "native-integrations-shared-strings": "static-1.8117",
  "sanitize": "static-1.4812",
  "superstore": "static-1.5099",
  "ui-shepherd-react": "static-3.10610",
  "ai-settings-ui-library": "static-1.8393",
  "hub-http-janus": "static-1.887",
  "hubspotter-http": "static-1.4889",
  "immutable-less": "static-1.4991",
  "marketplace-ui-client-types": "static-1.18212",
  "nav-meta": "static-1.30542",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18430",
  "ui-product-approvals-common": "static-1.1180",
  "ai-studio-lib": "static-1.12507",
  "hubspot-prosemirror": "static-1.19049",
  "integrations-reconnect-lib": "static-1.538",
  "ui-addon-iframeable": "static-1.9417",
  "ui-addon-integrations-directory-panel": "static-2.8367",
  "ui-product-approvals": "static-1.29285",
  "ui-tool-access": "static-1.10495",
  "inbound-db-properties-service-client": "static-1.4073",
  "property-management-common": "static-1.6492",
  "opentelemetry-fe-types": "static-1.116",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.583",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.491",
  "quartz-auth": "static-1.1182",
  "quartz-test": "static-1.1182",
  "quartz-tracking": "static-1.886",
  "trellis-components": "static-1.2755",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.416",
  "HubStyle": "static-2.12139",
  "bender-build-tools": "static-1.3452",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23184",
  "ContentUtils": "static-1.69201",
  "customer-data-objects-ui-components": "static-1.13371",
  "sassPrefix": "static-1.229",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.473",
  "batch-promise": "static-1.1885",
  "event-emitter": "static-1.1295",
  "fast-json-patch": "static-1.70",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5784",
  "magpie-types": "static-1.5244",
  "stylex-utils": "static-1.147",
  "trellis-theming": "static-1.1313",
  "avatar-components": "static-1.2822",
  "breeze-engine-core": "static-1.1111",
  "breeze-onboarding-components": "static-1.806",
  "customer-data-filters-ui": "static-1.41025",
  "customer-data-reference-ui-components": "static-1.13519",
  "embedded-academy-lib": "static-1.15640",
  "ExportDialog": "static-6.10718",
  "global-styles-ai-lib": "static-1.212",
  "highlight.js": "static-1.86",
  "marketplace-embed-ba": "static-1.686",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42134",
  "reporting-snowflake": "static-1.57539",
  "reporting-ui-components": "static-2.66192",
  "reporting-visualizations": "static-1.60997",
  "trial-components-library": "static-1.14170",
  "ui-addon-teams": "static-1.21951",
  "upgrade-components-lib": "static-1.567",
  "navigation-components": "static-1.18905",
  "breeze-engine-lib": "static-1.1833",
  "simple-logging-lib": "static-1.3391",
  "fail-safe": "static-1.294",
  "app-governance-lib": "static-1.2458",
  "developer-experience-shared-components": "static-1.10878",
  "purchase-motions-components": "static-1.6427",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10376",
  "usage-tracker-anonymous": "static-1.6070",
  "usage-tracker-public": "static-1.7464",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.4042",
  "reference-resolvers": "static-1.8521",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4257",
  "hubspot-apollo-cache": "static-1.676",
  "universal-page-editor-lib": "static-1.3348",
  "final-form": "static-1.78",
  "redux-toolkit": "static-1.78",
  "simple-data-table": "static-1.3582",
  "merchandise-lib": "static-1.279",
  "ui-addon-draggable": "static-3.5097",
  "content-assistance-lib": "static-1.8248",
  "content-media-capture": "static-1.5520",
  "customer-data-ui-utilities": "static-1.10171",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24587",
  "growth-payments-core": "static-1.26257",
  "knowledge-content-types": "static-1.8685",
  "PatternValidationJS": "static-1.3232",
  "payment-link-components": "static-1.24219",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20356",
  "ui-addon-emoji-picker": "static-1.10224",
  "ui-business-units-lib": "static-1.9431",
  "video-components-external": "static-1.12214",
  "video-data-lib": "static-1.35872",
  "navigation-messaging": "static-1.8232",
  "collaboration-sidebar": "static-1.58796",
  "crm-component-utils": "static-1.39917",
  "crm-properties-common-lib": "static-1.6230",
  "customer-data-properties": "static-1.52696",
  "external-options-client-types": "static-1.4366",
  "framework-data-schema-resolvers": "static-1.7233",
  "property-value-citations": "static-1.3310",
  "reference-resolvers-lite": "static-1.8444",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.44",
  "hubspotter-http-shared-msw-handlers": "static-1.10679",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "cms-field-types": "static-1.5152",
  "content-icons-ui": "static-1.2403",
  "atom": "static-1.5422",
  "idb-keyval": "static-1.51",
  "reactive-lib": "static-1.1059",
  "breeze-artifacts-sdk": "static-1.458",
  "getting-started-shared-tasks": "static-1.19318",
  "onboarding-journeys-lib": "static-1.1009",
  "onboarding-scopes": "static-1.6793",
  "conversations-skeleton-state": "static-1.7587",
  "crm-message-bus": "static-1.43842",
  "customer-data-filters-ui-msw-helpers": "static-1.23460",
  "events-data-lib": "static-1.589",
  "FormUrlGenerator": "static-2.5066",
  "framework-builder-read-service-client": "static-1.4247",
  "hs-resources": "static-1.533",
  "multi-account-reference-resolvers": "static-1.1348",
  "onboarding-tours": "static-1.17187",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14533",
  "academy-common-lib": "static-1.15100",
  "dashboard-lib": "static-1.82958",
  "hubspot-prosemirror-plugins": "static-1.19041",
  "share-with-third-party-component-lib": "static-1.9048",
  "ui-asset-management-lib": "static-1.11440",
  "user-context": "static-1.5461",
  "reporting-plugins": "static-1.10802",
  "reporting-reports": "static-1.68599",
  "hubs-service-types": "static-1.1600",
  "purchase-motions-api": "static-1.6430",
  "salesImages": "static-1.600",
  "signup-constants": "static-1.19687",
  "nest": "static-1.577",
  "breeze-engine-chat-components": "static-1.811",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.245",
  "framework-listing-lib": "static-2.29570",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31505",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4573",
  "signup-ui-url-generator": "static-2.8400",
  "onboarding-tours-client": "static-1.5402",
  "one-click-checkout": "static-1.489",
  "platform-infra-nav-components": "static-1.7919",
  "subscription-experience-data-types": "static-1.15277",
  "crm-record-cards-service-types": "static-1.3796",
  "location-customization-utils-lib": "static-1.10171",
  "redux-thunk": "static-2.80",
  "react-flip-move": "static-1.78",
  "ui-coaching-tips": "static-1.29377",
  "content-media-composition-data-lib": "static-1.13324",
  "fix-webm-duration": "static-1.30",
  "notification-sounds": "static-1.4765",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.799",
  "ui-addon-opt": "static-4.8706",
  "commerce-tours-lib": "static-1.6673",
  "growth-onboarding-reliability": "static-1.5420",
  "sales-checkout-service-client": "static-1.3868",
  "data-token-picker": "static-1.16937",
  "FileManagerLib": "static-1.40227",
  "content-media-compositions": "static-2.17331",
  "media-bridge-lib": "static-1.19455",
  "chatspot-widget-iframe": "static-1.23175",
  "collaboration-sidebar-common": "static-1.3593",
  "marketing-platform-lib": "static-1.7213",
  "card-properties-lib": "static-1.45086",
  "commerce-subscription-lib": "static-1.37855",
  "crm-actions": "static-1.6689",
  "crm-cards-sdk": "static-1.44678",
  "customer-data-properties-shared-msw-handlers": "static-1.10008",
  "customer-data-tracking": "static-1.7222",
  "calling-global-api": "static-1.65743",
  "calling-internal-common": "static-1.31662",
  "calling-lifecycle-internal": "static-1.67125",
  "calling-lifecycle-messages": "static-1.59419",
  "commerce-products-lib": "static-1.10617",
  "conditional-properties-service-client": "static-1.4042",
  "crm-index-visualization-core": "static-1.4588",
  "crm-links": "static-1.6658",
  "crm-pipelines-api-client-types": "static-1.4373",
  "formula-editor": "static-1.14821",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4454",
  "meetings-icalendar-utils-lib": "static-1.975",
  "multi-currency-client-types": "static-1.3933",
  "object-builder-ui-client": "static-1.49762",
  "pipeline-validation-client-types": "static-1.4208",
  "smart-data-capture-core": "static-1.203",
  "smart-property-lib": "static-1.8374",
  "tiered-pricing": "static-1.2017",
  "topics-actions-lib": "static-1.510",
  "ui-addon-form-validation": "static-1.11324",
  "zustand": "static-1.85",
  "fdsr-migration-layer": "static-1.352",
  "framework-data-schema-quick-fetch": "static-1.7138",
  "restore-request-side-panel-lib": "static-1.1744",
  "growth-data-modal": "static-1.5944",
  "growth-onboarding-confetti": "static-1.3405",
  "growth-onboarding-next-action-utils": "static-1.2757",
  "onboarding-tours-utils": "static-1.1254",
  "ui-shepherd-tracker": "static-1.7991",
  "academy-service-client": "static-1.4032",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40086",
  "SafeStorage": "static-1.4746",
  "video-embed": "static-1.36706",
  "redux-actions": "static-3.70",
  "EmailSignatureEditor": "static-1.25059",
  "viral-links-lib": "static-1.7416",
  "nested-table": "static-1.575",
  "timezone-utils": "static-2.5583",
  "getting-started-shared-tasks-store": "static-1.18436",
  "campaign-roi-lib": "static-1.10424",
  "campaigns-utils-lib": "static-1.3563",
  "ui-addon-calendars": "static-2.5681",
  "customer-data-views-management": "static-1.26091",
  "framework-data-table": "static-2.12615",
  "nudge-client-utils": "static-1.3200",
  "nudge-custom-ui-functions": "static-1.1546",
  "switchboard-lib": "static-1.560",
  "access-check-ui-lib": "static-1.1658",
  "app-users-service-client": "static-1.5960",
  "app-users-service-types": "static-1.5368",
  "mini-checkout-client": "static-1.27584",
  "onboarding-utils": "static-1.5711",
  "permissions-shared-i18n-strings-fe": "static-1.2123",
  "ui-coaching-tips-shared-config": "static-1.29362",
  "checkout-sdk": "static-3.24427",
  "payment-method-components": "static-1.7187",
  "touchless-buying-components": "static-1.6295",
  "upgrade-catalog-service-types": "static-1.3796",
  "edison-service-client-types": "static-1.734",
  "growth-onboarding-feedback-components": "static-1.6925",
  "audio-components": "static-1.6394",
  "FileManagerImages": "static-1.37738",
  "video-components": "static-1.14216",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92921",
  "customer-data-sidebar": "static-2.46801",
  "enrichment-lib": "static-1.535",
  "ui-addon-draggable-compat": "static-2.4603",
  "universal-record-utils-lib": "static-1.2071",
  "commerce-billing-lib": "static-1.20284",
  "commerce-shared-components-lib": "static-1.19309",
  "commerce-tools-ui-lib": "static-1.11110",
  "crm-fe-perf": "static-1.23238",
  "calling-error-reporting": "static-1.31669",
  "shared-worker-versioning": "static-1.11381",
  "calling-usage-tracker": "static-1.6876",
  "voice-sms-access-library": "static-1.2138",
  "commerce-permissions": "static-1.1117",
  "products-iframe-lib": "static-1.8651",
  "products-ui-components-shared-msw-handlers": "static-1.11063",
  "crm-index-associations-lib": "static-1.6784",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10764",
  "sales-views-client-types": "static-1.4596",
  "bark-lib": "static-1.16855",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.702",
  "policy-lib": "static-1.7145",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10827",
  "onboarding-data-sync-lib": "static-1.2567",
  "growth-onboarding-next-action-components": "static-1.2785",
  "user-context-client": "static-1.4848",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4870",
  "outpost": "static-1.4493",
  "draft-convert": "static-2.80",
  "draft-extend": "static-3.83",
  "draft-js": "static-5.85",
  "draft-plugins": "static-2.22208",
  "sales-email-signature-service-client": "static-1.4187",
  "ts-utils-lib": "static-1.488",
  "copilot-messaging": "static-1.2160",
  "crm-export-dialog": "static-1.6623",
  "crm-index-ui-shimmer": "static-1.2738",
  "crm-view-components": "static-1.1258",
  "react-beautiful-dnd": "static-1.70",
  "customer-data-associations": "static-1.7670",
  "tasks-actions-lib": "static-1.209",
  "nudge-custom-function-registry": "static-1.2957",
  "nudge-renderer-utils": "static-1.3276",
  "whisper-core-api": "static-1.7397",
  "InboxConnectUtils": "static-4.15623",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46913",
  "hub-http-rxjs": "static-1.854",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4332",
  "company-details-components": "static-1.6547",
  "react-performance-metrics-lib": "static-1.893",
  "pricing-pages-ui-components": "static-1.15981",
  "quote-checkout-service-types": "static-1.3792",
  "social-insights-client-types": "static-1.22706",
  "crm_universal": "static-1.22543",
  "customer-data-email": "static-1.18571",
  "card-payment-highlight-lib": "static-1.38070",
  "commerce-contract-lib": "static-1.13451",
  "invoices-highlight-card-lib": "static-1.55851",
  "orders-highlight-card-lib": "static-1.22260",
  "products-highlight-card-lib": "static-1.18900",
  "quotes-highlight-card-lib": "static-1.72850",
  "crm-source-interpretation-lib": "static-1.5671",
  "data-agent-utils": "static-1.597",
  "crm-object-search-query-utilities": "static-1.10253",
  "utility-belt": "static-1.2873",
  "payments-enrollment-embed-lib": "static-1.23911",
  "stripe-embedded-components": "static-1.8043",
  "customer-data-rte": "static-1.33707",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6334",
  "payments-post-enroll-local-storage-lib": "static-1.5444",
  "qrcode-generator": "static-1.76",
  "quotes-client-types": "static-1.38940",
  "calling-orchestration-schema": "static-1.36915",
  "react-reducer-toolkit": "static-1.16432",
  "meetings-connect-utils-lib": "static-1.7951",
  "hub-http-contrib": "static-1.3380",
  "ui-addon-sales-email": "static-1.5554",
  "access-control-lib": "static-1.10777",
  "EmailComponents": "static-1.55619",
  "EmailData": "static-1.54297",
  "redux-less": "static-2.9815",
  "company-details-service-types": "static-1.4283",
  "segments-query-core": "static-1.1764",
  "pricing-pages-api": "static-1.15846",
  "sequences-lib": "static-1.8582",
  "ui-gdpr-components": "static-1.10636",
  "products-ui-components": "static-1.41135",
  "accounting-integrations-ui-components": "static-1.7586",
  "invoices-ui-lib": "static-1.55867",
  "commerce-products-api": "static-1.2732",
  "invoices-iframe-lib": "static-1.57925",
  "quotes-modal-lib": "static-1.103528",
  "quotes-ui-lib": "static-1.81571",
  "stripe-connect-js": "static-1.78",
  "draft-content-plugins": "static-1.28965",
  "ContentComponents": "static-2.72157",
  "ContentData": "static-1.69276",
  "marketing-email-service-types": "static-1.2119",
  "messaging-editing-lib": "static-1.47219",
  "messaging-usage-based-billing-components-lib": "static-1.2081",
  "automation-ui-source-apps": "static-1.19754",
  "automation-ui-types": "static-1.20672",
  "messaging-types-lib": "static-1.46956",
  "onboarding-settings-client": "static-1.4849",
  "sequences-client-types-lib": "static-1.8439",
  "commerce-tax-lib": "static-1.880",
  "price-books-api": "static-1.1796",
  "price-books-components": "static-1.1854",
  "property-description-translator": "static-1.4177",
  "ramp-editor": "static-1.951",
  "commerce-analytics-service-client": "static-1.3856",
  "totals-ui-components": "static-1.24354",
  "SalesContentIndexUI": "static-3.9665",
  "advanced-menus-core": "static-1.15627",
  "advanced-menus-lib": "static-1.12498",
  "automation-ui-ubb": "static-1.6588",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7677",
  "data-token-views": "static-1.16918",
  "forms-utils-lib": "static-1.13141",
  "payments-embed-points-lib": "static-1.13647",
  "react-tinymce": "static-1.56047",
  "simple-menus-core": "static-1.15626",
  "simple-menus-lib": "static-1.17143",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55173",
  "tinymce-data": "static-1.41258",
  "tinymce-plugins": "static-1.58287",
  "tinymce-themes": "static-1.57143",
  "ui-brand-identity-lib": "static-1.16627",
  "ui-memberships-settings-lib": "static-1.34910",
  "videoconference-integration-components": "static-1.7341",
  "automation-applications-service-types": "static-1.3662",
  "automation-platform-service-types": "static-1.2673",
  "ContentEditorUI": "static-2.77985",
  "content-whatsapp-service-types": "static-1.578",
  "short-messages-app-service-client": "static-1.4259",
  "web-interactives-components": "static-1.14297",
  "web-interactives-data": "static-1.14298",
  "messaging-shared-utils-lib": "static-1.1530",
  "messaging-user-info-utils-lib": "static-1.1700",
  "email-portal-health-service-types": "static-1.1322",
  "line-items-api": "static-1.1140",
  "commerce-totals-service-types": "static-1.4058",
  "FireAlarmUi": "static-1.4750",
  "sales-templates-service-types-lib": "static-1.4410",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22608",
  "automation-ui-usage-tracking": "static-1.22071",
  "data-studio-ubb": "static-1.3577",
  "interframe": "static-3.5095",
  "layout-dnd-components": "static-1.13022",
  "layout-dnd-utils": "static-1.11997",
  "NamespacedHubStyle": "static-2.9291",
  "campaigns-lib": "static-1.27720",
  "content-management-data-lib": "static-1.6017",
  "copilot-plugins": "static-1.11882",
  "cta-picker": "static-1.37146",
  "customer-agent-discovery-components-lib": "static-1.4024",
  "editor-components": "static-1.13699",
  "editor-iframe-lib": "static-1.8845",
  "error-messaging-js": "static-1.5539",
  "FormsCommonComponents": "static-1.86643",
  "layout-data-lib": "static-1.10322",
  "pictos": "static-7.191",
  "react-transition-group": "static-2.73",
  "redux-request-state": "static-1.10987",
  "SharedLegalStrings": "static-1.2082",
  "smart-content-core": "static-1.43240",
  "smart-content-lib": "static-1.43893",
  "social-composer-lib": "static-1.60349",
  "structured-content-lib": "static-1.25983",
  "theme-previewer-lib": "static-1.53971",
  "tinymce-copilot": "static-1.17241",
  "xray-recommendation-lib": "static-1.8305",
  "automation-ui-routing": "static-1.22029",
  "sql-reporting-client-types": "static-1.5921",
  "attribution-lib": "static-1.42851",
  "reporting-enablement": "static-1.23898",
  "forms-ai-lib": "static-1.4810",
  "codemirror-dlb": "static-1.59544",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6782",
  "report-customization-components": "static-1.13972",
  "data-quality-ui-library": "static-1.13936",
  "reporting-filters": "static-1.1060",
  "reporting-insights-lib": "static-1.2652",
  "merge-modal-lib": "static-1.12692",
  "segments-client-types": "static-1.11683"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13303",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.866",
  "client-types": "/client-types/static-1.501",
  "data-fetching-client": "/data-fetching-client/static-1.9993",
  "foundations-components": "/foundations-components/static-1.8549",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1574",
  "foundations-theming": "/foundations-theming/static-1.4816",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.89",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8373",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10681",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "HubStyleTokens": "/HubStyleTokens/static-2.11832",
  "I18n": "/I18n/static-7.1679",
  "jasmine-runner": "/jasmine-runner/static-1.6790",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.697",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13366",
  "quartz": "/quartz/static-1.7507",
  "react-dlb": "/react-dlb/static-1.89",
  "react-rhumb": "/react-rhumb/static-1.17063",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3194",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10856",
  "reselect": "/reselect/static-3.12",
  "settings-ui-lib": "/settings-ui-lib/static-1.12864",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7675",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11486",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9872",
  "unified-auth": "/unified-auth/static-1.984",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1266",
  "usage-tracker": "/usage-tracker/static-1.7653",
  "usage-tracker-core": "/usage-tracker-core/static-1.7503",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8438",
  "hub-http": "/hub-http/static-1.6552",
  "integrations-lib": "/integrations-lib/static-1.17142",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20805",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.791",
  "property-management-iframe": "/property-management-iframe/static-1.14204",
  "quartz-config": "/quartz-config/static-1.1285",
  "quartz-core": "/quartz-core/static-1.6726",
  "quartz-routing": "/quartz-routing/static-1.937",
  "quick-fetch": "/quick-fetch/static-1.4153",
  "react": "/react/static-7.196",
  "rpc-client-utils": "/rpc-client-utils/static-1.5006",
  "ts-schema": "/ts-schema/static-1.4319",
  "ui-universal-auth": "/ui-universal-auth/static-1.9470",
  "UIComponents": "/UIComponents/static-3.8778",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.87",
  "metrics-js": "/metrics-js/static-1.9963",
  "react-redux": "/react-redux/static-7.79",
  "redux": "/redux/static-4.80",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3784",
  "quartz-webpack": "/quartz-webpack/static-1.3731",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.585",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9795",
  "codemirror": "/codemirror/static-5.102",
  "foundations-assets": "/foundations-assets/static-1.5227",
  "pulse": "/pulse/static-1.970",
  "react-codemirror": "/react-codemirror/static-1.10983",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.679",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4818",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2532",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-story-utils": "/hs-story-utils/static-1.9765",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.78",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5581",
  "react-virtualized": "/react-virtualized/static-2.107",
  "StyleGuideUI": "/StyleGuideUI/static-3.507",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2736",
  "ui-fonts": "/ui-fonts/static-1.1094",
  "ui-images": "/ui-images/static-2.1262",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3299",
  "foundations-theming-base": "/foundations-theming-base/static-1.3801",
  "stylex": "/stylex/static-1.41",
  "HeadJS": "/HeadJS/static-2.803",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3484",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4652",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9042",
  "ai-rendering-library": "/ai-rendering-library/static-1.11165",
  "chirp-fetch": "/chirp-fetch/static-1.2236",
  "connections-embed-lib": "/connections-embed-lib/static-1.1565",
  "copilot-toolkit": "/copilot-toolkit/static-1.11910",
  "feedback-loader": "/feedback-loader/static-1.29861",
  "laboratory-lib": "/laboratory-lib/static-3.7493",
  "marketplace-embed": "/marketplace-embed/static-1.22983",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10700",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20760",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14975",
  "sanitize-text": "/sanitize-text/static-1.8497",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6067",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5339",
  "wootric-nps": "/wootric-nps/static-1.7226",
  "quartz-head": "/quartz-head/static-1.1172",
  "web-vitals": "/web-vitals/static-1.15",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4997",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4486",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2716",
  "reporting-data": "/reporting-data/static-1.68923",
  "cssUtils": "/cssUtils/static-1.962",
  "flux-actions": "/flux-actions/static-1.373",
  "react-colorpicker": "/react-colorpicker/static-2.10553",
  "react-dnd-compat": "/react-dnd-compat/static-1.4956",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10710",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7643",
  "icons": "/icons/static-2.693",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19337",
  "storybook-react": "/storybook-react/static-1.40",
  "trellis-story-utils": "/trellis-story-utils/static-1.4847",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6032",
  "quartz-i18n": "/quartz-i18n/static-1.1182",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.535",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1504",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.34",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1098",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.217",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.554",
  "slack-ui-library": "/slack-ui-library/static-1.10739",
  "fsm": "/fsm/static-1.4093",
  "customer-data-objects": "/customer-data-objects/static-1.8037",
  "property-translator": "/property-translator/static-1.5734",
  "hs-locale-management": "/hs-locale-management/static-1.320",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8259",
  "hs-promise-utils": "/hs-promise-utils/static-1.5930",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5217",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14557",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5948",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8117",
  "sanitize": "/sanitize/static-1.4812",
  "superstore": "/superstore/static-1.5099",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10610",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8393",
  "hub-http-janus": "/hub-http-janus/static-1.887",
  "hubspotter-http": "/hubspotter-http/static-1.4889",
  "immutable-less": "/immutable-less/static-1.4991",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18212",
  "nav-meta": "/nav-meta/static-1.30542",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18430",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1180",
  "ai-studio-lib": "/ai-studio-lib/static-1.12507",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19049",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.538",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9417",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8367",
  "ui-product-approvals": "/ui-product-approvals/static-1.29285",
  "ui-tool-access": "/ui-tool-access/static-1.10495",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4073",
  "property-management-common": "/property-management-common/static-1.6492",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.116",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.583",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.491",
  "quartz-auth": "/quartz-auth/static-1.1182",
  "quartz-test": "/quartz-test/static-1.1182",
  "quartz-tracking": "/quartz-tracking/static-1.886",
  "trellis-components": "/trellis-components/static-1.2755",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.416",
  "HubStyle": "/HubStyle/static-2.12139",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23184",
  "ContentUtils": "/ContentUtils/static-1.69201",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13371",
  "sassPrefix": "/sassPrefix/static-1.229",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.473",
  "batch-promise": "/batch-promise/static-1.1885",
  "event-emitter": "/event-emitter/static-1.1295",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5784",
  "magpie-types": "/magpie-types/static-1.5244",
  "stylex-utils": "/stylex-utils/static-1.147",
  "trellis-theming": "/trellis-theming/static-1.1313",
  "avatar-components": "/avatar-components/static-1.2822",
  "breeze-engine-core": "/breeze-engine-core/static-1.1111",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.806",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41025",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13519",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15640",
  "ExportDialog": "/ExportDialog/static-6.10718",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.212",
  "highlight.js": "/highlight.js/static-1.86",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.686",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42134",
  "reporting-snowflake": "/reporting-snowflake/static-1.57539",
  "reporting-ui-components": "/reporting-ui-components/static-2.66192",
  "reporting-visualizations": "/reporting-visualizations/static-1.60997",
  "trial-components-library": "/trial-components-library/static-1.14170",
  "ui-addon-teams": "/ui-addon-teams/static-1.21951",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.567",
  "navigation-components": "/navigation-components/static-1.18905",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1833",
  "simple-logging-lib": "/simple-logging-lib/static-1.3391",
  "fail-safe": "/fail-safe/static-1.294",
  "app-governance-lib": "/app-governance-lib/static-1.2458",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10878",
  "purchase-motions-components": "/purchase-motions-components/static-1.6427",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10376",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6070",
  "usage-tracker-public": "/usage-tracker-public/static-1.7464",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.4042",
  "reference-resolvers": "/reference-resolvers/static-1.8521",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4257",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.676",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3348",
  "final-form": "/final-form/static-1.78",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "simple-data-table": "/simple-data-table/static-1.3582",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5097",
  "content-assistance-lib": "/content-assistance-lib/static-1.8248",
  "content-media-capture": "/content-media-capture/static-1.5520",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10171",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24587",
  "growth-payments-core": "/growth-payments-core/static-1.26257",
  "knowledge-content-types": "/knowledge-content-types/static-1.8685",
  "PatternValidationJS": "/PatternValidationJS/static-1.3232",
  "payment-link-components": "/payment-link-components/static-1.24219",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20356",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10224",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9431",
  "video-components-external": "/video-components-external/static-1.12214",
  "video-data-lib": "/video-data-lib/static-1.35872",
  "navigation-messaging": "/navigation-messaging/static-1.8232",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58796",
  "crm-component-utils": "/crm-component-utils/static-1.39917",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6230",
  "customer-data-properties": "/customer-data-properties/static-1.52696",
  "external-options-client-types": "/external-options-client-types/static-1.4366",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7233",
  "property-value-citations": "/property-value-citations/static-1.3310",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8444",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.44",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10679",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "cms-field-types": "/cms-field-types/static-1.5152",
  "content-icons-ui": "/content-icons-ui/static-1.2403",
  "atom": "/atom/static-1.5422",
  "idb-keyval": "/idb-keyval/static-1.51",
  "reactive-lib": "/reactive-lib/static-1.1059",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.458",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19318",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1009",
  "onboarding-scopes": "/onboarding-scopes/static-1.6793",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7587",
  "crm-message-bus": "/crm-message-bus/static-1.43842",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23460",
  "events-data-lib": "/events-data-lib/static-1.589",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5066",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4247",
  "hs-resources": "/hs-resources/static-1.533",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1348",
  "onboarding-tours": "/onboarding-tours/static-1.17187",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14533",
  "academy-common-lib": "/academy-common-lib/static-1.15100",
  "dashboard-lib": "/dashboard-lib/static-1.82958",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19041",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9048",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11440",
  "user-context": "/user-context/static-1.5461",
  "reporting-plugins": "/reporting-plugins/static-1.10802",
  "reporting-reports": "/reporting-reports/static-1.68599",
  "hubs-service-types": "/hubs-service-types/static-1.1600",
  "purchase-motions-api": "/purchase-motions-api/static-1.6430",
  "salesImages": "/salesImages/static-1.600",
  "signup-constants": "/signup-constants/static-1.19687",
  "nest": "/nest/static-1.577",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.811",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.245",
  "framework-listing-lib": "/framework-listing-lib/static-2.29570",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31505",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4573",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8400",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5402",
  "one-click-checkout": "/one-click-checkout/static-1.489",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7919",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15277",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10171",
  "redux-thunk": "/redux-thunk/static-2.80",
  "react-flip-move": "/react-flip-move/static-1.78",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29377",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13324",
  "fix-webm-duration": "/fix-webm-duration/static-1.30",
  "notification-sounds": "/notification-sounds/static-1.4765",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.799",
  "ui-addon-opt": "/ui-addon-opt/static-4.8706",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6673",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5420",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3868",
  "data-token-picker": "/data-token-picker/static-1.16937",
  "FileManagerLib": "/FileManagerLib/static-1.40227",
  "content-media-compositions": "/content-media-compositions/static-2.17331",
  "media-bridge-lib": "/media-bridge-lib/static-1.19455",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23175",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3593",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7213",
  "card-properties-lib": "/card-properties-lib/static-1.45086",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37855",
  "crm-actions": "/crm-actions/static-1.6689",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44678",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10008",
  "customer-data-tracking": "/customer-data-tracking/static-1.7222",
  "calling-global-api": "/calling-global-api/static-1.65743",
  "calling-internal-common": "/calling-internal-common/static-1.31662",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67125",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59419",
  "commerce-products-lib": "/commerce-products-lib/static-1.10617",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4042",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4588",
  "crm-links": "/crm-links/static-1.6658",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4373",
  "formula-editor": "/formula-editor/static-1.14821",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4454",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.975",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3933",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49762",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4208",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.203",
  "smart-property-lib": "/smart-property-lib/static-1.8374",
  "tiered-pricing": "/tiered-pricing/static-1.2017",
  "topics-actions-lib": "/topics-actions-lib/static-1.510",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11324",
  "zustand": "/zustand/static-1.85",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.352",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7138",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1744",
  "growth-data-modal": "/growth-data-modal/static-1.5944",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3405",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2757",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1254",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7991",
  "academy-service-client": "/academy-service-client/static-1.4032",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40086",
  "SafeStorage": "/SafeStorage/static-1.4746",
  "video-embed": "/video-embed/static-1.36706",
  "redux-actions": "/redux-actions/static-3.70",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25059",
  "viral-links-lib": "/viral-links-lib/static-1.7416",
  "nested-table": "/nested-table/static-1.575",
  "timezone-utils": "/timezone-utils/static-2.5583",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18436",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10424",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3563",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5681",
  "customer-data-views-management": "/customer-data-views-management/static-1.26091",
  "framework-data-table": "/framework-data-table/static-2.12615",
  "nudge-client-utils": "/nudge-client-utils/static-1.3200",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1546",
  "switchboard-lib": "/switchboard-lib/static-1.560",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1658",
  "app-users-service-client": "/app-users-service-client/static-1.5960",
  "app-users-service-types": "/app-users-service-types/static-1.5368",
  "mini-checkout-client": "/mini-checkout-client/static-1.27584",
  "onboarding-utils": "/onboarding-utils/static-1.5711",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2123",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29362",
  "checkout-sdk": "/checkout-sdk/static-3.24427",
  "payment-method-components": "/payment-method-components/static-1.7187",
  "touchless-buying-components": "/touchless-buying-components/static-1.6295",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3796",
  "edison-service-client-types": "/edison-service-client-types/static-1.734",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6925",
  "audio-components": "/audio-components/static-1.6394",
  "FileManagerImages": "/FileManagerImages/static-1.37738",
  "video-components": "/video-components/static-1.14216",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92921",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46801",
  "enrichment-lib": "/enrichment-lib/static-1.535",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4603",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2071",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20284",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19309",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11110",
  "crm-fe-perf": "/crm-fe-perf/static-1.23238",
  "calling-error-reporting": "/calling-error-reporting/static-1.31669",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11381",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6876",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2138",
  "commerce-permissions": "/commerce-permissions/static-1.1117",
  "products-iframe-lib": "/products-iframe-lib/static-1.8651",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11063",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6784",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10764",
  "sales-views-client-types": "/sales-views-client-types/static-1.4596",
  "bark-lib": "/bark-lib/static-1.16855",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.702",
  "policy-lib": "/policy-lib/static-1.7145",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10827",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2567",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2785",
  "user-context-client": "/user-context-client/static-1.4848",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4870",
  "outpost": "/outpost/static-1.4493",
  "draft-convert": "/draft-convert/static-2.80",
  "draft-extend": "/draft-extend/static-3.83",
  "draft-js": "/draft-js/static-5.85",
  "draft-plugins": "/draft-plugins/static-2.22208",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4187",
  "ts-utils-lib": "/ts-utils-lib/static-1.488",
  "copilot-messaging": "/copilot-messaging/static-1.2160",
  "crm-export-dialog": "/crm-export-dialog/static-1.6623",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2738",
  "crm-view-components": "/crm-view-components/static-1.1258",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.70",
  "customer-data-associations": "/customer-data-associations/static-1.7670",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.209",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2957",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3276",
  "whisper-core-api": "/whisper-core-api/static-1.7397",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15623",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46913",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.854",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4332",
  "company-details-components": "/company-details-components/static-1.6547",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.893",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15981",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3792",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "crm_universal": "/crm_universal/static-1.22543",
  "customer-data-email": "/customer-data-email/static-1.18571",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38070",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13451",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55851",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22260",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18900",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72850",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5671",
  "data-agent-utils": "/data-agent-utils/static-1.597",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10253",
  "utility-belt": "/utility-belt/static-1.2873",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23911",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8043",
  "customer-data-rte": "/customer-data-rte/static-1.33707",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6334",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5444",
  "qrcode-generator": "/qrcode-generator/static-1.76",
  "quotes-client-types": "/quotes-client-types/static-1.38940",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36915",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16432",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7951",
  "hub-http-contrib": "/hub-http-contrib/static-1.3380",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5554",
  "access-control-lib": "/access-control-lib/static-1.10777",
  "EmailComponents": "/EmailComponents/static-1.55619",
  "EmailData": "/EmailData/static-1.54297",
  "redux-less": "/redux-less/static-2.9815",
  "company-details-service-types": "/company-details-service-types/static-1.4283",
  "segments-query-core": "/segments-query-core/static-1.1764",
  "pricing-pages-api": "/pricing-pages-api/static-1.15846",
  "sequences-lib": "/sequences-lib/static-1.8582",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10636",
  "products-ui-components": "/products-ui-components/static-1.41135",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7586",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55867",
  "commerce-products-api": "/commerce-products-api/static-1.2732",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57925",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103528",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81571",
  "stripe-connect-js": "/stripe-connect-js/static-1.78",
  "draft-content-plugins": "/draft-content-plugins/static-1.28965",
  "ContentComponents": "/ContentComponents/static-2.72157",
  "ContentData": "/ContentData/static-1.69276",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2119",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47219",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2081",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19754",
  "automation-ui-types": "/automation-ui-types/static-1.20672",
  "messaging-types-lib": "/messaging-types-lib/static-1.46956",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4849",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8439",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.880",
  "price-books-api": "/price-books-api/static-1.1796",
  "price-books-components": "/price-books-components/static-1.1854",
  "property-description-translator": "/property-description-translator/static-1.4177",
  "ramp-editor": "/ramp-editor/static-1.951",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3856",
  "totals-ui-components": "/totals-ui-components/static-1.24354",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9665",
  "advanced-menus-core": "/advanced-menus-core/static-1.15627",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12498",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6588",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7677",
  "data-token-views": "/data-token-views/static-1.16918",
  "forms-utils-lib": "/forms-utils-lib/static-1.13141",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13647",
  "react-tinymce": "/react-tinymce/static-1.56047",
  "simple-menus-core": "/simple-menus-core/static-1.15626",
  "simple-menus-lib": "/simple-menus-lib/static-1.17143",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55173",
  "tinymce-data": "/tinymce-data/static-1.41258",
  "tinymce-plugins": "/tinymce-plugins/static-1.58287",
  "tinymce-themes": "/tinymce-themes/static-1.57143",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16627",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34910",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7341",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3662",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2673",
  "ContentEditorUI": "/ContentEditorUI/static-2.77985",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.578",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4259",
  "web-interactives-components": "/web-interactives-components/static-1.14297",
  "web-interactives-data": "/web-interactives-data/static-1.14298",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1530",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1700",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1322",
  "line-items-api": "/line-items-api/static-1.1140",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4058",
  "FireAlarmUi": "/FireAlarmUi/static-1.4750",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4410",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22608",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22071",
  "data-studio-ubb": "/data-studio-ubb/static-1.3577",
  "interframe": "/interframe/static-3.5095",
  "layout-dnd-components": "/layout-dnd-components/static-1.13022",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11997",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9291",
  "campaigns-lib": "/campaigns-lib/static-1.27720",
  "content-management-data-lib": "/content-management-data-lib/static-1.6017",
  "copilot-plugins": "/copilot-plugins/static-1.11882",
  "cta-picker": "/cta-picker/static-1.37146",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4024",
  "editor-components": "/editor-components/static-1.13699",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8845",
  "error-messaging-js": "/error-messaging-js/static-1.5539",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86643",
  "layout-data-lib": "/layout-data-lib/static-1.10322",
  "pictos": "/pictos/static-7.191",
  "react-transition-group": "/react-transition-group/static-2.73",
  "redux-request-state": "/redux-request-state/static-1.10987",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2082",
  "smart-content-core": "/smart-content-core/static-1.43240",
  "smart-content-lib": "/smart-content-lib/static-1.43893",
  "social-composer-lib": "/social-composer-lib/static-1.60349",
  "structured-content-lib": "/structured-content-lib/static-1.25983",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53971",
  "tinymce-copilot": "/tinymce-copilot/static-1.17241",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8305",
  "automation-ui-routing": "/automation-ui-routing/static-1.22029",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5921",
  "attribution-lib": "/attribution-lib/static-1.42851",
  "reporting-enablement": "/reporting-enablement/static-1.23898",
  "forms-ai-lib": "/forms-ai-lib/static-1.4810",
  "codemirror-dlb": "/codemirror-dlb/static-1.59544",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6782",
  "report-customization-components": "/report-customization-components/static-1.13972",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13936",
  "reporting-filters": "/reporting-filters/static-1.1060",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2652",
  "merge-modal-lib": "/merge-modal-lib/static-1.12692",
  "segments-client-types": "/segments-client-types/static-1.11683"
}
};
